export default __webpack_public_path__ + "static/media/logo-navbar.31791b90.svg";